export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/darkness": [5,[2]],
		"/darkness/!": [6,[2]],
		"/darkness/draw": [7,[2]],
		"/minis/[uuid]": [8],
		"/posts/2022/12/25/hii__3": [9,[3]],
		"/posts/2023/1/1/happy_new_year!": [10,[3]],
		"/posts/2023/5/13/Rewriting_my_Wave_Function_Collapse_demo_in_Rust": [11,[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';